export default `
§ sidebar.switch.team: チーム
§ sidebar.switch.person: 従業員
§ sidebar.buttons.settings: 設定
§ sidebar.buttons.print: 印刷
§ sidebar.buttons.share: Share
§ sidebar.buttons.logout: Logout
§ sidebar.filters.all: すべての時間
§ sidebar.filters.year: 年
§ sidebar.filters.halfYear: 半年
§ sidebar.filters.month: 月
§ sidebar.filters.week: 週間
§ sidebar.team.total: 般的な情報
§ sidebar.team.scope: モジュール
§ sidebar.team.author: スタッフ
§ sidebar.team.type: タスクの種類
§ sidebar.team.pr: コード注入
§ sidebar.team.day: 日によって
§ sidebar.team.week: 週ごと
§ sidebar.team.month: 月別
§ sidebar.team.tree: ファイルの分析
§ sidebar.team.files: ファイル
§ sidebar.team.removedFiles: 削除されたファイル
§ sidebar.team.extension: Extensions
§ sidebar.team.tasks: タスクリスト
§ sidebar.team.release: Releases
§ sidebar.team.hours: スケジュール
§ sidebar.team.commits: All commits
§ sidebar.team.changes: すべての変更
§ sidebar.team.words: 人気のある言葉
§ sidebar.team.building: クイズ
§ sidebar.team.refactor: Refactoring
§ sidebar.team.company: Companies
§ sidebar.team.country: Locations
§ sidebar.team.settings: 設定
§ sidebar.person.total: 一般的な情報
§ sidebar.person.money: 仕事のコスト
§ sidebar.person.speed: スピード
§ sidebar.person.day: 日によって
§ sidebar.person.week: 週ごと
§ sidebar.person.month: 月別
§ sidebar.person.tasks: Tasks
§ sidebar.person.hours: スケジュール
§ sidebar.person.commits: All commits
§ sidebar.person.changes: すべての変更
§ sidebar.person.words: 人気のある言葉
§ sidebar.person.settings: 設定
`;
